import AddressDisplay from 'common/components/address/AddressDisplay';
import AddressOnlyDisplay from 'common/components/address/AddressOnlyDisplay';

import CustomerDisplay from './CustomerDisplay';
import RombauerPickupBy from './RombauerPickupBy';

const Customer = (props) => {
  const { cart, customer, currentStep, onEdit, settings } = props;
  if (currentStep === 'customer') {
    return null;
  }
  const handleEdit = (e) => {
    e.preventDefault();
    onEdit('customer');
  };
  if (
    currentStep === 'carrierPickupLocation' ||
    currentStep === 'shipping' ||
    currentStep === 'payment' ||
    currentStep === 'complete'
  ) {
    return (
      <>
        <div>
          <div>
            <div>Contact information</div>
            <div>
              <CustomerDisplay cart={cart} customer={customer} />
            </div>
          </div>
          <a
            href="#"
            aria-label="Edit contact information"
            onClick={handleEdit}
          >
            Edit
          </a>
        </div>
        {renderAddress(cart, settings, handleEdit)}
        {cart.giftMessage && renderGiftMessage(cart.giftMessage, handleEdit)}
        {cart.shippingInstructions &&
          renderShippingInstructions(cart.shippingInstructions, handleEdit)}
      </>
    );
  }
  return null;
};

const renderAddress = (cart, settings, handleEdit) => {
  if (cart.orderDeliveryMethod === 'Pickup') {
    return (
      <div>
        <div>
          <div>Pickup address</div>
          <div>
            <AddressOnlyDisplay address={cart.pickupBy} />
            <RombauerPickupBy cart={cart} />
          </div>
        </div>
        <a href="#" aria-label="Edit pickup address" onClick={handleEdit}>
          Edit
        </a>
      </div>
    );
  }
  if (cart.orderDeliveryMethod === 'Carry Out') {
    return (
      <div>
        <div>
          <div>Pickup address</div>
          <div>
            <AddressOnlyDisplay address={cart.carryOut} />
            <RombauerPickupBy cart={cart} />
          </div>
        </div>
        <a href="#" aria-label="Edit pickup address" onClick={handleEdit}>
          Edit
        </a>
      </div>
    );
  }
  return (
    <div>
      <div>
        <div>Shipping address</div>
        <div>
          <AddressDisplay address={cart.shipTo} />
        </div>
      </div>
      <a href="#" aria-label="Edit shipping address" onClick={handleEdit}>
        Edit
      </a>
    </div>
  );
};

const renderGiftMessage = (message, handleEdit) => (
  <div>
    <div>
      <div>Gift message</div>
      <div>{message}</div>
    </div>
    <a href="#" aria-label="Edit gift message" onClick={handleEdit}>
      Edit
    </a>
  </div>
);

const renderShippingInstructions = (shippingInstructions, handleEdit) => (
  <div>
    <div>
      <div>Shipping Instructions</div>
      <div>{shippingInstructions}</div>
    </div>
    <a href="#" aria-label="Edit shipping instructions" onClick={handleEdit}>
      Edit
    </a>
  </div>
);
export default Customer;
